<template>
  <div class="partner">
    <div class="partnerTitle">合作伙伴</div>
    <div class="partnerEn">ECO-PARTNERS</div>
    <div class="partnerBox">
      <div v-for="(item, index) in arr" :key="index" class="partnerBoxItem">
        <div class="partnerBoxItemTitle">{{ item.title }}</div>
        <div class="partnerBoxItemPhotos">
          <img v-for="(child, index) in item.mobilePhotos" :key="index" :src="child" alt="" class="partnerBoxItemPhotosImg" />
        </div>
      </div>
    </div>
    <img src="https://p0.ssl.qhimg.com/t110b9a93010764ee5cf8c5f4b1.png" alt="" class="partnerBg" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps(['arr'])
const arr = props.arr || {}
</script>

<style lang="scss" scoped>
.partner {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 40px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 16px;
  }
  &Box {
    z-index: 20;
    border-radius: 16px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    padding: 27px 12px;
    &Item {
      margin-bottom: 16px;
      &Title {
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin-bottom: 8px;
      }
      &Photos {
        display: flex;
        flex-wrap: wrap;
        gap: 7px 6px;
        &Img {
          // width: 75px;
          width: 23%;
          height: 28px;
          display: block;
        }
      }
    }
    &Item:last-child {
      margin-bottom: 0;
    }
  }
  &Bg {
    position: absolute;
    top: 55px;
    right: 0;
    width: 86px;
  }
}
</style>
